import { useContext } from 'react';
import { AppContext } from '../context/context';
import { getToken } from '../components/authentication/functions/authentication_management';

/**
 * Custom hook that abstracts authentication state
 * Provides convenient access to authentication status throughout the app
 */
export function useAuth() {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useAuth must be used within the app context provider");
  }

  const { userData } = context;
  const { userDetails } = userData;
  const token = getToken();

  const isAuthenticated = !!token;

  return {
    user: userDetails,
    isAuthenticated,
    token
  };
}
